import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { ROLL_FORWARD_WIZARD_STEPS } from "../../roll_forward_wizard_steps";
import { useRollForwardWizardStore } from "../../roll_forward_wizard_store";
import css from "./wizard_header.module.scss";

export const WizardHeader = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });
  const activeStep = useRollForwardWizardStore((state) => state.activeStep);

  return (
    <Stack>
      <Inline alignItems="center" gap="spacingMd">
        <Icon name="rollforward" size="lg" />
        <Typography variant="h1">{t("title")}</Typography>
      </Inline>
      <Typography variant="bodyRegular" tag="span" className={css.subtitle}>
        {t(ROLL_FORWARD_WIZARD_STEPS[activeStep].subtitleKey)}
      </Typography>
    </Stack>
  );
};
